/* eslint-disable react-hooks/exhaustive-deps */
import { useApi } from '@backstage/core-plugin-api';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../../../../apis/notificationApi';
import { toolsProvisioningApiRef } from '../../../../../../apis/toolsProvisioningApi';
import { useEffect, useState } from 'react';
import { IConfigData } from '../../../../interfaces';
import { useGetProvisionedTools } from './useGetProvisionedTools';

export const useSettingsOperations = (
  apmNumber: string | undefined,
  shouldcall: boolean,
) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const toolsprovisioningApi = useApi(toolsProvisioningApiRef);
  const [updatingFormat, setUpdatingFormat] = useState<boolean>(false);

  const updateAcceptanceCriteriaFormat = async (settings: any) => {
    setUpdatingFormat(true);
    if (toolsprovisioningApi) {
      try {
        const response =
          await toolsprovisioningApi.updateAcceptanceCriteriaFormat(settings);
        if (response?.status === 200) {
          setUpdatingFormat(false);
          notificationApi.sendNotification({
            message: 'Format updated successfully', // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setUpdatingFormat(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  return {
    updateAcceptanceCriteriaFormat,
    updatingFormat,
  } as const;
};
